<template>
    <div class="matched-bets">
        <div class="green--text">
            <v-checkbox
                v-if="betDataMatchedPremium.length && forBets"
                v-model="showAverage"
                label="Average Odds"
                hide-details
                class="my-0 caption top-0 ml-2"
                dense
            ></v-checkbox>
        </div>
        <div v-if="showAverage">
            <!-- <pre>{{ betDataMatchedPremium }}</pre> -->
            <average-bets-premium
                :bets="betDataMatchedPremium"
            ></average-bets-premium>
        </div>
        <div v-if="!showAverage">
            <template v-for="(bet, j) in betDataMatchedPremium">
                <ob-card-premium
                    :key="`ob-card-${j}`"
                    :bets-data="betDataMatchedPremium"
                    :bets-group="bet"
                ></ob-card-premium>
                <!-- <v-divider :key="'divider-' + j"></v-divider> -->
            </template>
        </div>
        <div v-if="!betDataMatchedPremium">
            <no-data-found
                bet-text="No Matched Bets!"
                icon-custom="mdi mdi-alert"
            />
        </div>
    </div>
</template>

<script>
import ObCardPremium from "@/components/open-bets/ObCardPremium"
import AverageBetsPremium from "@/components/open-bets/AverageBetsPremium"
export default {
    components: {
        ObCardPremium,
        AverageBetsPremium
    },
    data() {
        return {
            showAverage: false,
            forBets: true
        }
    },
    props: {
        betDataMatchedPremium: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    created() {
        // console.log('aaaaa', this.$route.name === 'bets')

        if (this.$route.name === "bets") {
            this.forBets = false
        }
    },

    methods: {
        openAll(v) {
            return [...v.keys()].map((k, i) => i)
        }
    }
}
</script>
<style lang="scss" scoped>
.pre-odds {
    .v-expansion-panel {
        border: none !important;
        border-radius: o !important;
    }
}
</style>
